<p-message [dt]="props.dt?.components?.message" [severity]="props.severity" variant="simple" size="small">
  {{ props.label }}
</p-message>
